var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInboundNumbers = function SvgInboundNumbers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inbound_numbers_svg2__a",
    x1: 32.05,
    x2: 178.6,
    y1: 165.72,
    y2: 15.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#inbound_numbers_svg2__a",
    id: "inbound_numbers_svg2__c",
    x1: 34.01,
    x2: 180.56,
    y1: 167.63,
    y2: 17.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m189.03 15.62-13.04-14.5c-1.35-1.5-3.55-1.5-4.9 0l-32.46 36.06-8.95-9.94c-.43-.48-.97-.82-1.55-1-1.85-.55-3.75.67-4.24 2.72l-13.11 54.37c-.08.33-.12.66-.12 1 0 2.12 1.55 3.85 3.46 3.85.3 0 .6-.04.9-.13l48.95-14.57a3.4 3.4 0 0 0 1.55-.99c1.35-1.5 1.36-3.94 0-5.44l-8.95-9.94 32.47-36.05c1.35-1.5 1.35-3.94 0-5.44ZM150 53.52c-.38.21-.74.5-1.04.88-1.24 1.54-1.16 3.88.16 5.31.07.08.14.16.22.24l7.04 7.83-37.36 11.12 10.01-41.5 7.16 7.95s.05.05.07.08c1.37 1.48 3.56 1.44 4.9-.08.12-.14.23-.29.32-.44l32.07-35.62 8.15 9.05-31.68 35.19Z",
    style: {
      fill: "url(#inbound_numbers_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09 122.04c-1.35-1.5-3.55-1.5-4.9 0l-21.78 24.19-58.02-64.45 21.78-24.19c1.35-1.5 1.35-3.94 0-5.44L46.5 14.76c-1.35-1.5-3.55-1.5-4.9 0L23.57 34.78c-18.16 20.17-18.16 52.87 0 73.04l69.39 77.08c8.71 9.69 20.55 15.13 32.88 15.1 12.33.02 24.17-5.41 32.88-15.1l18.03-20.02c1.35-1.5 1.35-3.94 0-5.44l-33.66-37.39Zm10.73 57.42c-15.43 17.14-40.53 17.14-55.96 0l-69.39-77.07c-15.43-17.14-15.43-45.03 0-62.16l15.58-17.31 28.77 31.95-21.78 24.19c-1.35 1.5-1.35 3.94 0 5.44l62.92 69.89c1.35 1.5 3.55 1.5 4.9 0l21.78-24.19 28.77 31.95-15.58 17.31Z",
    style: {
      fill: "url(#inbound_numbers_svg2__c)",
      strokeWidth: 0
    }
  }));
};
export default SvgInboundNumbers;